import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  IconButton,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { ArrowForward } from "@material-ui/icons";
import { isNil } from "lodash";
import { useTranslation } from "react-i18next";
import useFilters from "../../store/hooks/useFilters";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(2),
  },
  title: {
    fontSize: 14,
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  btn: {
    border: "1px solid",
  },
}));

const FilterRange = ({ filter, selectedRange, onChange }) => {
  const classes = useStyles();
  const [min, setMin] = useState("");
  const [max, setMax] = useState("");
  const { t } = useTranslation();
  const { blockFilters } = useFilters();

  const handleApply = () => {
    if (blockFilters) {
      return;
    }

    onChange({ min: Number(min), max: Number(max) });
  };

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleApply();
    }
  };

  useEffect(() => {
    // min
    if (!isNil(selectedRange?.min)) {
      setMin(selectedRange?.min);
    } else {
      setMin(filter?.min);
    }

    // max
    if (!isNil(selectedRange?.max)) {
      setMax(selectedRange?.max);
    } else {
      setMax(filter?.max);
    }
  }, [filter, selectedRange]);

  const isFillterApplied = useMemo(() => {
    return selectedRange?.min !== "" || selectedRange?.max !== "";
  }, [selectedRange]);

  return (
    <Box className={classes.root}>
      <Typography variant="h6" className={classes.title}>
        {filter?.name} {isFillterApplied ? "" : " (all)"}
      </Typography>
      <Box display="flex" alignItems="center">
        <TextField
          margin="dense"
          variant="outlined"
          size="small"
          label={t("EMPLOYEE_STORE.MIN")}
          type="number"
          InputProps={{ inputProps: { min: 0 } }}
          style={{ marginRight: 8, width: 100 }}
          value={min}
          onChange={(e) => setMin(e.target.value)}
          onKeyDown={handleEnter}
          disabled={blockFilters}
        />
        <TextField
          margin="dense"
          variant="outlined"
          size="small"
          label={t("EMPLOYEE_STORE.MAX")}
          type="number"
          InputProps={{ inputProps: { min: 0 } }}
          style={{ marginRight: 8, width: 100 }}
          value={max}
          onChange={(e) => setMax(e.target.value)}
          onSubmit={handleApply}
          onKeyDown={handleEnter}
          disabled={blockFilters}
        />
        <IconButton
          color="primary"
          size="small"
          className={classes.btn}
          onClick={handleApply}
          disabled={blockFilters}
        >
          <ArrowForward />
        </IconButton>
      </Box>
    </Box>
  );
};

export default FilterRange;
